"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";
import Image from "../../assets/images/WorkDesk.jpg"
import ContactButton from '../../components/shared/ContactButton';

export function  AssessmentSA() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28  bg-[#02172A] text-white">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <p className="mb-3 font-semibold md:mb-4">Behalten Sie den Überblick</p>
            <h1 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[45px] lg:text-[45px] max-w-[500px]">
            Vorteile einer Sicherheitsbewertung
            </h1>
          
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Proaktive Risikoerkennung                </h6>
                <p>
                Durch frühzeitige Identifikation von Schwachstellen können Sie proaktiv Maßnahmen ergreifen, bevor es zu Sicherheitsvorfällen kommt.
                </p>
              </div>
              <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Compliance-Sicherheit                </h6>
                <p>
                Stellen Sie sicher, dass Ihr Unternehmen alle relevanten gesetzlichen und branchenspezifischen Sicherheitsstandards erfüllt.
                </p>
              </div>
              
              <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Compliance-Sicherheit                </h6>
                <p>
                Stellen Sie sicher, dass Ihr Unternehmen alle relevanten gesetzlichen und branchenspezifischen Sicherheitsstandards erfüllt.
                </p>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
            {/* <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Call-to-Action                </h6>
                <p className="mb-5">
                Vereinbaren Sie noch heute einen Termin für eine Sicherheitsbewertung und schützen Sie Ihr Unternehmen vor zukünftigen Cyberbedrohungen
                </p>
                <p>Durch die Implementierung dieser SEO-optimierten Inhalte auf Ihren Unterseiten können Sie die Sichtbarkeit Ihrer Website in Suchmaschinen erhöhen und potenzielle Kunden effektiver ansprechen.</p>
              </div> */}
              <ContactButton/>
            </div>
          </div>
          <div>
            <img
              src={Image}
              className="w-full object-cover rounded-xl"
              alt="Relume placeholder image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
